import * as ReactBootstrap from 'react-bootstrap'
import { BooleanConverter, titleCaseByUnderscore } from '../../components'
import { RightToggleButton } from './RightToggleButton'
import React from 'react'

export const OrganizationRightsTable = ({
  userOrganizationRight,
  onChange,
}) => {
  return (
    <ReactBootstrap.Table striped bordered hover size="sm">
      <tbody>
        <tr>
          <th>Repair Inventory</th>
          <td>{BooleanConverter(userOrganizationRight.repair_inventory)}</td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'repair_inventory'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>Loaner Inventory</th>
          <td>{BooleanConverter(userOrganizationRight.loaner_inventory)}</td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'loaner_inventory'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>Non Serialized Inventory</th>
          <td>
            {BooleanConverter(userOrganizationRight.non_serialized_inventory)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'non_serialized_inventory'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>

        <tr>
          <th>Tickets</th>
          <td>{BooleanConverter(userOrganizationRight.tickets)}</td>
          <td className="text-center">
            <RightToggleButton
              onChange={onChange}
              right={userOrganizationRight}
              property={'tickets'}
            />
          </td>
        </tr>
        <tr>
          <th>Customer Report Download</th>
          <td>
            {BooleanConverter(userOrganizationRight.customer_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'customer_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>

        <tr>
          <th>Delivery Report Download</th>
          <td>
            {BooleanConverter(userOrganizationRight.delivery_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'delivery_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>{titleCaseByUnderscore('loaner_record_report_download')}</th>
          <td>
            {BooleanConverter(
              userOrganizationRight.loaner_record_report_download
            )}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'loaner_record_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>
            {titleCaseByUnderscore('non_serialized_order_line_report_download')}
          </th>
          <td>
            {BooleanConverter(
              userOrganizationRight.non_serialized_order_line_report_download
            )}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'non_serialized_order_line_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>{titleCaseByUnderscore('order_line_report_download')}</th>
          <td>
            {BooleanConverter(userOrganizationRight.order_line_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'order_line_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>{titleCaseByUnderscore('status_report_download')}</th>
          <td>
            {BooleanConverter(userOrganizationRight.status_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'status_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>{titleCaseByUnderscore('token_report_download')}</th>
          <td>
            {BooleanConverter(userOrganizationRight.token_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'token_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>
        <tr>
          <th>{titleCaseByUnderscore('voucher_report_download')}</th>
          <td>
            {BooleanConverter(userOrganizationRight.voucher_report_download)}
          </td>
          <td className="text-center">
            {userOrganizationRight.url ? (
              <RightToggleButton
                onChange={onChange}
                right={userOrganizationRight}
                property={'voucher_report_download'}
              />
            ) : (
              ''
            )}
          </td>
        </tr>


      </tbody>
    </ReactBootstrap.Table>
  )
}
